// extracted by mini-css-extract-plugin
module.exports = {"bb-detail-meta":"bb-detail-meta__LMqP7"};